import script from "./TaskEditModeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskEditModeCard.vue?vue&type=script&setup=true&lang=js"

import "./TaskEditModeCard.vue?vue&type=style&index=0&id=cfde7838&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfde7838"]])

export default __exports__